import { render } from "./InputChips.vue?vue&type=template&id=12eab4aa&scoped=true"
import script from "./InputChips.vue?vue&type=script&lang=js"
export * from "./InputChips.vue?vue&type=script&lang=js"

import "./InputChips.vue?vue&type=style&index=0&id=12eab4aa&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/facilitabots.interagev2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12eab4aa"]])

export default __exports__